import LiquidMetal from "liquidmetal";
import { QuickScoreAdapter } from "./QuickScoreAdapter";
export class LiquidmetalAdapter extends QuickScoreAdapter {
    constructor() {
        super(...arguments);
        this.name = "liquidmetal";
    }
    get defaultOptions() {
        return {
            scorer: (query, target) => LiquidMetal.score(query, target)
        };
    }
}
